export default __webpack_public_path__ + "static/media/undraw_lost_1.a5d55033.svg";